const deBrandedDomains = [
  {
    domain: 'understandsolarpower',
    logoUrl: 'https://understandsolarpower.com/assets/img/uss-logo-350.png',
    copyrightText: 'Understandsolarpower',
  },
  {
    domain: 'solarcost',
    logoUrl: 'https://solarcost.org/assets/img/solarcost_logo_2.png',
    copyrightText: 'Solarcost',
  },
  {
    domain: 'homesolar-power',
    logoUrl: 'https://homesolar-power.com/assets/img/HSP350x43.png',
    copyrightText: 'Homesolar-power',
  },
  {
    domain: 'solarpower-pro',
    logoUrl: 'https://solarpower-pro.com/assets/img/spp-logo.png',
    copyrightText: 'Solarpower-pro',
  },
  {
    domain: 'justsolar-power.com',
    copyrightText: 'Justsolar-power',
  },
  {
    domain: 'topsolar-power.com',
    copyrightText: 'Topsolar-power',
  },
  {
    domain: 'yourchoicesolar.com',
    copyrightText: 'Yourchoicesolar',
  },
  {
    domain: 'mysolar-power.com',
    copyrightText: 'Mysolar-power',
  },
  {
    domain: 'solar-understood.com',
    copyrightText: 'Solar-understood',
  },
  {
    domain: 'solarunderstood.com',
    copyrightText: 'Solarunderstood',
  },
  {
    domain: 'firstcallsolar.com',
    copyrightText: 'Firstcallsolar',
  },
  {
    domain: 'bestsolar-power.com',
    copyrightText: 'Bestsolar-power',
  },
  {
    domain: 'bigsolar-power.com',
    copyrightText: 'Bigsolar-power',
  },
  {
    domain: 'instantsolar.org',
    copyrightText: 'Instantsolar',
  },
  {
    domain: 'drsolar-power.com',
    copyrightText: 'Drsolar-power',
  },
  {
    domain: 'seemysavings.com',
    copyrightText: 'Seemysavings',
  },
  {
    domain: 'solarxyz.com',
    copyrightText: 'Solarxyz',
  },
  {
    domain: 'californiasolarbenefits.com',
    copyrightText: 'Californiasolarbenefits',
  },
  {
    domain: 'floridasolarbenefits.com',
    copyrightText: 'Floridasolarbenefits',
  },
  {
    domain: 'texassolarbenefits.com',
    copyrightText: 'Texassolarbenefits',
  },
  {
    domain: 'floridasolardeals.com',
    copyrightText: 'Floridasolardeals',
  },
  {
    domain: 'texassolardeals.com',
    copyrightText: 'Texassolardeals',
  },
  {
    domain: 'californiasolardeals.com',
    copyrightText: 'Californiasolardeals',
  },
];

export default deBrandedDomains;
